<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")
  section.u-mt-md
    .grid
      .column.is-widescreen-6
        ValidationObserver(ref="observer")
          form(slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" novalidate)
            TextInput(
              v-model="firstName"
              type="text"
              :label="$t('forms.fname')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="lastName"
              type="text"
              :label="$t('forms.lname')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="email"
              type="email"
              :label="$t('forms.email')"
              rules="required|email"
              :disabled="isSubmitting"
            )

            PhoneInput(
              :name="$t('forms.phone')"
              type="text"
              :label="$t('forms.phone')"
              v-model="phone"
              rules="required"
              ref="phoneNumber"
            )

            TextInput(
              v-model="title"
              type="text"
              :label="$t('forms.subject')"
              rules="required"
              :disabled="isSubmitting"
            )
            TextInput(
              v-model="message"
              type="textarea"
              :label="$t('forms.message')"
              rules="required"
              :disabled="isSubmitting"
            )
            .u-mb-ts
              recaptcha(@error="onError" @success="onSuccess" @expired="onExpired")
            button.button-link.is-medium(v-load="isSubmitting") {{$t('forms.send')}}
      .column.is-widescreen-3.is-offset-widescreen-2.u-mt-sm
        h6.u-mb-ts {{$t('email')}}
        p.u-mb-ts {{$t('emailDesc')}}
        a.u-bold(href="mailto:Hello@baianat.com", title="Hello@baianat.com") Hello@baianat.com
        h6.u-mb-ts.u-mt-sm {{$t('phone')}}
        p.u-mb-ts {{$t('phoneDesc')}}
        a.u-bold.u-ltr(href="tel:00201000111888", title="002 01000111888") 002 01000111888
        ul.u-list-unstyled.u-mt-sm
          li.u-mb-xs
            AppLink(to="/cc" :title="$t('customerCare')" class="button-link is-small is-black") {{$t('customerCare')}}


  section.u-mt-md
    .grid.is-tablet-6.is-labs
      .column.u-mb-col
        AppCardBox
          AppLink(to="/feedback" :title="$t('feedback')"  class="cardBox-url")
          h4 {{$t('feedback')}}
          p {{$t('feedbackDesc')}}
      .column.u-mb-col
        AppCardBox
          AppLink(to="/knowledgebase" :title="$t('knowledgebase')"  class="cardBox-url")
          h4 {{$t('knowledgebase')}}
          p {{$t('knowledgebaseDesc')}}
  .u-mb-md
</template>

<script>
import { mapActions } from 'vuex';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import PhoneInput from '~/components/inputs/PhoneInput';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';
import { CreateInquiry } from '~/graphql/Shame.gql';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'contact'
  },
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    TextInput,
    PhoneInput,
    ValidationObserver
  },
  directives: {
    load
  },
  data: () => ({
    email: '',
    title: '',
    message: '',
    name: '',
    firstName: '',
    lastName: '',
    phone: '',
    recaptchaValid: false,
    isSubmitting: false,
    invalidatedPhone: false
  }),
  created() {
    if (this.$store.state.auth.isLoggedIn) {
      const user = this.$store.state.auth.user;
      this.email = user.email;
      this.name = `${user.firstName} ${user.lastName}`;
    }
  },
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    }),
    async onSubmit() {
      let input = this.$refs.phoneNumber.$refs.input;
      if (this.invalidatedPhone) {
        this.invalidatedPhone = false;
        input.classList.remove('has-error');
        document.getElementById('phone_error_').remove();
      }
      if (this.phone.trim() == '' || !this.phone.length) {
        let input = this.$refs.phoneNumber.$refs.input;
        input.classList.add('has-error');
        let error = document.createElement('p');
        error.id = 'phone_error_';
        error.classList.add('form-error');
        error.textContent = 'The Subject field is required';
        input.parentNode.parentNode.insertBefore(error, input.parentNode.nextSibling);
        this.invalidatedPhone = true;
        return false;
      }
      try {
        if (!this.recaptchaValid) {
          this.error(this.$t('forms.recaptchaRequired'));
          return;
        }
        this.isSubmitting = true;
        // const token = await this.$recaptcha.getResponse();
        // console.log(token);
        await this.$api.mutate({
          mutation: CreateInquiry,
          variables: {
            input: {
              type: 'CONTACT',
              title: this.title,
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              phone: this.phone,
              message: this.message,
              country: this.$refs.phoneNumber.country.name
            }
          }
        });

        this.title = '';
        this.name = '';
        this.email = '';
        this.message = '';
        this.phone = '';
        requestAnimationFrame(() => {
          this.$refs.observer.reset();
        });
        await this.$recaptcha.reset();
        this.recaptchaValid = false;
        this.success(this.$t('submitted'));
      } catch (err) {
        if (err.message) {
          this.error(err.message);
        } else {
          this.error(err);
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    onError(error) {
      console.log('Error happened:', error);
      this.recaptchaValid = false;
    },
    onSuccess(token) {
      console.log('Succeeded:', token);
      this.recaptchaValid = true;
    },
    onExpired() {
      // console.log('Expired');
      this.recaptchaValid = false;
    }
  },
  async mounted() {
    try {
      await this.$recaptcha.init();
    } catch (e) {
      console.error(e);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "submitted": "We got your ticket, we will get back to you shortly!",
    "pageTitle":"Contact",
    "pageDesc":"Say hello to Baianat team. Ask questions and submit your inquiries through the contact form to get instant support.",
    "mantra":"Say |hello.",
    "email":"Email",
    "phone":"Phone",
    "customerCare":"Customer care",
    "support":"Support",
    "emailDesc":"Feel free to email us all your questions or concerns regarding any of Baianat services.",
    "phoneDesc":"Reach us directly through calls, FaceTime or WhatsApp Phone",
    "knowledgebase":"Knowledge Base",
    "knowledgebaseDesc":"Search our knowledge base for answers to your burning questions.",
    "feedback":"Feedback",
    "feedbackDesc":"Help us better support you by leaving your feedback on our services, products or initiatives."
  },
  "ar": {
    "submitted": "تم ارسال رسالتك, سيصلك رد منا سريعاً",
    "pageTitle":"اتصل بنا",
    "pageDesc":"تحدث مع فريق بيانات واطرح الأسئلة التي تتبادر لذهنك وقدم جميع استفساراتك من خلال نموذج اتصل بنا لتحصل على الدعم الفوري",
    "mantra":"مرحبًا.",
    "email":"البريد الإلكتروني",
    "phone":"الهاتف",
    "customerCare":"خدمة العملاء",
    "support":"الدعم الفني",
    "emailDesc":"إذا كان لديك أي استفسار عن أي خدمة من خدمات بيانات لا تتردد في التواصل معنا على الفور. ",
    "phoneDesc":"تواصل معنا مباشرة من خلال المكالمات أو واتس آب.",
    "knowledgebase":"قاعدة المعرفة",
    "knowledgebaseDesc":"ابحث في قاعدة المعرفة الخاص بنا عن إجابات للأسئلة التي تشغل بالك.",
    "feedback":"شكاوى واقتراحات",
    "feedbackDesc":"يمكنك مساعدتنا في دعمك بشكل أفضل من خلال ترك تعليقاتك على خدماتنا أو منتجاتنا أو مبادراتنا."
  }
}
</i18n>
